import SlideOutDown from './slide-out-down'
import SlideOutLeft from './slide-out-left'
import SlideOutRight from './slide-out-right'
import SlideOutUp from './slide-out-up'

export default {
  SlideOutDown,
  SlideOutLeft,
  SlideOutRight,
  SlideOutUp
}



// WEBPACK FOOTER //
// ./src/animates/animated-vue/transitions/sliding-exits/index.js